import Step from '@mui/material/Step'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { OnboardPage } from '../../../helpers/onboard-helper'
import { getOnboardingStepPoints } from '../../../helpers/onboarding-points'
import useAppUtilities from '../../../hooks/useAppUtilities'
import { IStepper } from '../../../types'
import StepperIcon from './StepperIcon'
import {
  ColorLibConnector,
  OnboardingContainer,
  OnboardingStepLabel,
  OnboardingStepper,
  OnboardingTypography,
} from './styled/OnboardSteppar.styled'

interface OnboardStepperProps {
  activeStep: number
  steps: IStepper[]
}

const OnboardStepper: React.FC<OnboardStepperProps> = ({
  activeStep,
  steps,
}): JSX.Element => {
  const { theme, isSmallScreen } = useAppUtilities()

  return (
    <OnboardingContainer>
      <OnboardingStepper
        orientation={isSmallScreen ? 'horizontal' : 'vertical'}
        activeStep={activeStep}
        connector={<ColorLibConnector />}
      >
        {steps.map((step: IStepper, index) => (
          <Step
            key={step.title}
            style={{
              paddingLeft: isSmallScreen ? 0 : 8,
              paddingRight: isSmallScreen ? 0 : 8,
            }}
          >
            <OnboardingStepLabel
              StepIconComponent={(props) => (
                <StepperIcon
                  {...props}
                  activeStepCount={activeStep}
                  step={step.step}
                />
              )}
            >
              {!isSmallScreen && (
                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                  <OnboardingTypography
                    color={
                      step.step === activeStep
                        ? theme.palette.background.paper
                        : step.step < activeStep
                        ? theme.palette.background.paper
                        : theme.palette.grey[400]
                    }
                  >
                    {step.title}
                  </OnboardingTypography>
                  {/* Show points badge only for steps that award points and are not yet completed */}
                  {step.page &&
                    step.page !== 'CHOOSE_ROLE' &&
                    step.page !== 'DONE' &&
                    step.step > activeStep && (
                      (() => {
                        const pageEnum = OnboardPage[step.page as keyof typeof OnboardPage] as OnboardPage
                        const points = pageEnum ? getOnboardingStepPoints(pageEnum) : undefined
                        return points !== undefined ? (
                          <Typography
                            variant="caption"
                            color="success.main"
                            sx={{ fontWeight: 600 }}
                          >
                            +{points} pts
                          </Typography>
                        ) : null
                      })()
                    )}
                </Box>
              )}
            </OnboardingStepLabel>
          </Step>
        ))}
      </OnboardingStepper>
    </OnboardingContainer>
  )
}
OnboardStepper.displayName = 'OnboardStepper'

export default OnboardStepper
